var exports = {
  "k": "xfd349460--834c43--container",
};

module.exports = exports;
